
import Vuex from 'vuex'




export const store =  new Vuex.Store({
	state: {
		rightView: 'user-dash-quick-act',
		prop1: '',
		prop2: '',

		userDetails: [],
		userDetailsComp: '0',

		userLatestContacts: [],
		userLatestContactsComp: '0',

		userLatestQuotes: [],
		userLatestQuotesComp: '0',

		userLatestOrgs: [],
		userLatestOrgsComp: '0',

		inviteArray: [],
		inviteComp: '0',



	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2},

		setUserDetails(state, payload) { state.userDetails = payload.info; state.userDetailsComp = payload.info1; },
		setUserDetailsComp(state, payload) { state.userDetailsComp = payload.info1; },

		setUserLatestContacts(state, payload) { state.userLatestContacts = payload.info; state.userLatestContactsComp = payload.info1; },
		setUserLatestContactsComp(state, payload) { state.userLatestContactsComp = payload.info1; },

		setUserLatestQuotes(state, payload) { state.userLatestQuotes = payload.info; state.userLatestQuotesComp = payload.info1; },
		setUserLatestQuotesComp(state, payload) { state.userLatestQuotesComp = payload.info1; },

		setUserLatestOrgs(state, payload) { state.userLatestOrgs = payload.info; state.userLatestOrgsComp = payload.info1; },
		setUserLatestOrgsComp(state, payload) { state.userLatestOrgsComp = payload.info1; },

		setInvites(state, payload) { state.inviteArray = payload.info; state.inviteComp = payload.info1; },
		setInviteComp(state, payload) { state.inviteComp = payload.info1; },
		
  	},

	actions: {
		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2 })  },
		getUserDetails(context, payload) {
			context.commit("setUserDetailsComp", { info1: '0' }) 
			axios.get('/utility/user/user/getuserdetails')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setUserDetails", { info: b, info1: '1' }) 
	          	});
		},
		getLatestUserContacts(context, payload) {
			context.commit("setUserLatestContactsComp", { info1: '0' }) 
			axios.get('/utility/user/contact/getlatestcontactsbyuser')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setUserLatestContacts", { info: b, info1: '1' }) 
	          	});
		},
		getLatestUserOrgs(context, payload) {
			context.commit("setUserLatestOrgsComp", { info1: '0' }) 
			axios.get('/utility/user/org/getlatestorgsbyuser')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setUserLatestOrgs", { info: b, info1: '1' }) 
	          	});
		},
		getLatestUserQuotes(context, payload) {
			context.commit("setUserLatestQuotesComp", { info1: '0' }) 
			axios.get('/utility/user/quote/dashboardlatestquotes')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setUserLatestQuotes", { info: b, info1: '1' }) 
	          	});
		},
		
	}

})